import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'result', 'originalList', 'resultList']

  initialize () {
    this.timeout = null
  }

  reset (resetInputField = true) {
    if (resetInputField) this.fieldTarget.value = ''

    this.originalListTarget.style.display = 'block'
    this.resultListTarget.style.display = 'none'
    this.emptyResultList()
    this.fieldTarget.focus()
  }

  delayedSubmit (event) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(this.submit.bind(this, event), 500)
  }

  submit (event) {
    if (this.fieldTarget.value.length < 3 || event.keyCode === 27) {
      this.reset(!this.fieldTarget.value || event.keyCode === 27)
      return
    }

    this.originalListTarget.style.display = 'none'
    this.resultListTarget.style.display = 'block'
    this.emptyResultList()

    this.reduceAndSortResults(this.resultTargets).forEach(result => {
      this.resultListTarget.appendChild(result)
    })
  }

  reduceAndSortResults (results) {
    return results.reduce((filtered, result) => {
      if (result.querySelector('a').innerText.toLowerCase().includes(this.fieldTarget.value.toLowerCase())) {
        const clonedResult = result.cloneNode(true)
        clonedResult.removeAttribute('data-target')
        filtered.push(clonedResult)
      }
      return filtered
    }, []).sort((a, b) => {
      return a.querySelector('a').innerText.toLowerCase() > b.querySelector('a').innerText.toLowerCase() ? 1 : -1
    })
  }

  emptyResultList () {
    const resultList = this.resultListTarget

    while (resultList.firstChild) {
      resultList.removeChild(resultList.firstChild)
    }
  }
}
